<template>
  <div>
    
      <div class="px-8 py-4 bg-transparent flex justify-between items-center"  style="position: absolute; z-index: 3;">
                <logo style="height: 60px; width: 250px;"/>
                <div class="flex justify-end flex-row-reverse space-x-4 space-x-reverse" style="margin-left: 10px;margin-right: 50px;">
                  <inertia-link style="vertical-align: middle;"  class="btn-black text-inexorange" :href="route('register')">
                    <span>Registrarse</span>
                  </inertia-link>
                  <inertia-link style="vertical-align: middle;" class="btn-indigoOrange text-black" :href="route('login')">
                    <span>Iniciar Sesión</span>
                  </inertia-link>
              </div>
              
      </div>
      <div class="flex"  style="vertical-align: middle; position: absolute; z-index: 4; top: 30%;">

                <div class="justify-end whitespace-nowrap" style="margin-left: 190%;">
                  <br><br>
                 <h1 style="font-weight: 700; font-size: 25px; color: white;">
                  Convierte tu pasión <b style="color: #d4d712;">en progreso</b>
                 </h1><br>
                 <p style="font-weight: 400; font-size: 18px; color: white;">Crea tu perfil, sigue tu evolución física, escala en el</p><br>
                 <p style="font-weight: 400; font-size: 18px; color: white;">ranking y juega como un profesional.</p><br><br>
                 <p style="font-weight: 400; font-size: 18px; color: white;">Con PadelTrack, cada partido cuenta.</p>
              </div>
        </div>
        <carousel :perPage="1" :autoplay="true" style="position: relative; z-index: 2;">
  <slide>
   <!-- <form class="mt-6 bg-whiet rounded-lg shadow-xl overflow-hidden" @submit.prevent="login" style="position: absolute; z-index: 1; margin-top: 300px; margin-left: 700px;">
         <div class="px-10 py-1">
           <text-input v-model="form.email" :error="form.errors.email" style="color: white;" class="font-bold mt-2" type="email" autofocus autocapitalize="off" placeholder="Email"/>
           <text-input v-model="form.password" :error="form.errors.password" class="font-bold mt-2"  type="password" placeholder="Contraseña" />
         <div class="flex justify-center items-center">
           <loading-button :loading="form.processing" class="btn-indigoOrange" type="submit"  style="color: #D35400; align-content: end;">ENTRAR</loading-button>
         </div>
         </div>
       </form>-->
    <img src="/img/slider.jpg" style="height: 100%; width: 100%;  filter: brightness(90%);">
  </slide>
  <!--<slide>
    <img src="https://res.cloudinary.com/playtomic/image/upload/q_auto,f_auto/v1649677895/playtomic/web/banner.webp">

  </slide>-->
</carousel>
</div>
 </template>
 
 <script>
 import Logo from '@/Shared/Logo'
 import TextInput from '@/Shared/TextInputlogin'
 import LoadingButton from '@/Shared/LoadingButtonOrange'
 import axios from "axios";
 import { Carousel, Slide } from 'vue-carousel';
 
 export default {
   metaInfo: { title: 'Home' },
   components: {
     LoadingButton,
     Logo,
     TextInput,
     Carousel,
     Slide,
   },
   data() {
     return {
       mensagge: '',
       form: this.$inertia.form({
         email: '',
         password: '',
         remember: false,
         codigo: '',
         token: '',
       }),
     }
   },
   methods: {
     login() {
       this.form.post(this.route('login.store'))
     },
   },
 }
 </script>
 